import React from 'react';
import cn from 'classnames';

import {ITopBanner} from './ITopBannerV1';

import styles from './TopBannerV1.module.scss';

const TopBannerV1 = ({body, variant, scrollingStripeBanner}: ITopBanner) => {
	const isV2 = variant === 'TopBannerV2';

	return (
		<div className={cn(
			{
				[styles['module__top-banner__v1']]: !isV2,
				'top-banner__v1': !isV2,
				[styles['module__top-banner__v2']]: isV2,
				'top-banner__v2': isV2,
			}
		)}>
			{body}
			{scrollingStripeBanner &&
				<div className={styles['module__top-banner__ssb']}>
					{scrollingStripeBanner}
				</div>
			}
		</div>
	);
};

export default TopBannerV1;
